import { colors } from "./Colors";
export const bookData = [
  //PROGRAMMING
  {
    id: 1,
    topic: "Programming",
    header: "",
    icon: "",
    color: colors.Programming,
    books: [
      {
        id: 1,
        name: "Eloquent JavaScript",
        author: "Marijn Haverbeke",
        bookImage: "https://i.ibb.co/Jt81Kcp/eloquent-js-book-cover.jpg"
      },
      {
        id: 2,
        name: "The Pragmatic Programmer",
        author: "Andy Hunt & Dave Thomas",
        bookImage:
          "https://i.ibb.co/3cmdvFD/the-pragmatic-programmer-book-cover.jpg"
      },
      {
        id: 3,
        name: "Clean Code",
        author: "Robert C. Martin",
        bookImage: "https://i.ibb.co/Ky2kbRd/clean-code-book-cover.jpg"
      },
      {
        id: 4,
        name: "Code Complete",
        author: "Steve McConnell",
        bookImage: "https://i.ibb.co/2jBc2pz/code-complete-book-cover.jpg"
      },
      {
        id: 5,
        name: "Introduction to Algorithms",
        author: "Thomas H. Cormen",
        bookImage:
          "https://i.ibb.co/jDDpcRx/introduction-to-alogorithms-book-cover.jpg"
      },
      {
        id: 6,
        name: "Programming Pearls",
        author: "Jon L. Bentley",
        bookImage: "https://i.ibb.co/d0wT070/programming-pearls-book-cover.jpg"
      }
    ]
  },
  //THRILLER
  {
    id: 2,
    topic: "Thriller",
    header: "",
    icon: "",
    color: colors.Thriller,
    books: [
      {
        id: 1,
        name: "Five Survive",
        author: "Holly Jackson",
        bookImage: "https://i.ibb.co/TMwpcNk/five-survive-book-cover.jpg"
      },
      {
        id: 2,
        name: "You Can Hide",
        author: "Rebecca Zanetti",
        bookImage: "https://i.ibb.co/f8c2nWC/you-can-hide-book-cover.jpg"
      },
      {
        id: 3,
        name: "Are You Awake?",
        author: "Claire McGowan",
        bookImage: "https://i.ibb.co/MZGSbfy/are-you-awake-book-cover.jpg"
      },
      {
        id: 4,
        name: "Blackwater Falls",
        author: "Ausma Zehanat Khan",
        bookImage: "https://i.ibb.co/YbhTGft/black-water-falls-book-cover.jpg"
      },
      {
        id: 5,
        name: "The Wicked Remain",
        author: "Laura Pohl",
        bookImage: "https://i.ibb.co/ggCtSnt/the-wicked-remain-book-cover.jpg"
      },
      {
        id: 6,
        name: "All The Blood We Share",
        author: "Camilla Bruce",
        bookImage:
          "https://i.ibb.co/pyS3ws3/all-the-blood-we-share-book-cover.jpg"
      }
    ]
  },
  //SELF HELP
  {
    id: 3,
    topic: "Self Help",
    header: "",
    icon: "",
    color: colors.selfHelp,
    books: [
      {
        id: 1,
        name: "The Subtle Art of Not Giving a F*ck",
        author: "Mark Manson",
        bookImage:
          "https://i.ibb.co/MRwNcgk/the-subtle-art-of-not-giving-a-fuck-book-cover.jpg"
      },
      {
        id: 2,
        name: "How to Win Friends and Influence People",
        author: "Dale Carnegie",
        bookImage:
          "https://i.ibb.co/Fnj05Jz/how-to-wind-friends-and-inflence-people-book-cover.jpg"
      },
      {
        id: 3,
        name: "The 5 Love Languages",
        author: "Gary Chapman",
        bookImage:
          "https://i.ibb.co/zmq3CZ8/the-5-love-languages-book-cover.jpg"
      },
      {
        id: 4,
        name: "Atomic Habits",
        author: "James Clear",
        bookImage: "https://i.ibb.co/H2HHZqc/atomic-habits-book-cover.jpg"
      },
      {
        id: 5,
        name: "The Power of Now",
        author: "Eckhart Tolle",
        bookImage: "https://i.ibb.co/x3TFq2P/the-power-of-now-book-cover.jpg"
      },
      {
        id: 6,
        name: "Deep Work",
        author: "Cal Newport",
        bookImage: "https://i.ibb.co/p0K5PLR/deep-work-book-cover.jpg"
      }
    ]
  }
];
